import React from 'react'

import { SyncProblem } from '@mui/icons-material'
import { Tooltip, IconButton } from '@mui/material'
import { useDispatch } from 'react-redux'

import { updatePointsInHasura } from '../../actions/trackerActions'
import Loading from '../../components/Loading'
import { useSelector } from '../../hooks/useSelector'

import { unsyncedPointsSelector } from './worklogsHeaderSelectors'

export const SyncPoints = () => {
  const dispatch = useDispatch()
  const unsyncedPoints = useSelector(unsyncedPointsSelector)
  const { loading, success } = useSelector((state) => state.syncStatus)

  return (
    <div style={{ minWidth: '50px' }}>
      {loading ? (
        <Tooltip title={'Syncing worklogs to DB.'}>
          <div style={{ marginRight: 16 }}>
            <Loading />
          </div>
        </Tooltip>
      ) : (
        !success && (
          <Tooltip title={`Resync worklogs`}>
            <IconButton
              onClick={() =>
                dispatch(
                  updatePointsInHasura(
                    unsyncedPoints.map(([_, index]) => index)
                  )
                )
              }
              size="large"
            >
              <SyncProblem />
            </IconButton>
          </Tooltip>
        )
      )}
    </div>
  )
}
